import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Global } from "../helpers/Global";

export const ResetearPassword = () => {
  const [searchParams] = useSearchParams();

  // Token (robusto ante espacios/saltos)
  const tokenRaw = useMemo(() => searchParams.get("token") ?? "", [searchParams]);
  const token = useMemo(() => tokenRaw.trim(), [tokenRaw]);

  const [nuevaPassword, setNuevaPassword] = useState("");
  const [confirmarPassword, setConfirmarPassword] = useState("");

  const [mensaje, setMensaje] = useState("");
  const [tokenValido, setTokenValido] = useState(false);
  const [validando, setValidando] = useState(true);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    const validar = async () => {
      if (!token) {
        setValidando(false);
        setTokenValido(false);
        setMensaje("Token no válido.");
        return;
      }

      setValidando(true);
      setMensaje("");

      try {
        const url = `${Global.url}usuarios/password/reset/verify?token=${encodeURIComponent(token)}`;
        const res = await fetch(url);

        if (!res.ok) {
          const data = await res.json().catch(() => null);
          setTokenValido(false);
          setMensaje(data?.message || "Enlace inválido o expirado.");
        } else {
          setTokenValido(true);
        }
      } catch (error) {
        console.error("Error validando token:", error);
        setTokenValido(false);
        setMensaje("Error al validar el token.");
      } finally {
        setValidando(false);
      }
    };

    validar();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (guardando) return;

    if (nuevaPassword.length < 8) {
      setMensaje("La contraseña debe tener al menos 8 caracteres.");
      return;
    }
    if (nuevaPassword !== confirmarPassword) {
      setMensaje("Las contraseñas no coinciden.");
      return;
    }

    setGuardando(true);
    setMensaje("");

    try {
      const res = await fetch(`${Global.url}usuarios/password/reset`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, nuevaPassword }),
      });

      const data = await res.json().catch(() => null);

      if (!res.ok) {
        setMensaje(data?.message || "Error al establecer nueva contraseña.");
        return;
      }

      setMensaje(data?.message || "Contraseña actualizada correctamente");

      // Guardar token y usuario en localStorage (si vienen)
      if (data?.token) localStorage.setItem("token", data.token);
      if (data?.user) localStorage.setItem("user", JSON.stringify(data.user));

      setTimeout(() => {
        window.location.href = "/app/inicio";
      }, 1500);
    } catch (error) {
      console.error("Error al cambiar la contraseña:", error);
      setMensaje("Error al establecer nueva contraseña.");
    } finally {
      setGuardando(false);
    }
  };

  if (!tokenRaw) return <p className="rojo">Token no válido.</p>;
  if (validando) return <p>Validando enlace...</p>;
  if (!tokenValido) return <p className="rojo">{mensaje || "Enlace inválido o expirado."}</p>;

  return (
    <div className="cambiar-contrasena">
      <h2 className="centrar-titulo">Restablecer Contraseña</h2>

      {mensaje && <p className="rojo">{mensaje}</p>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Nueva Contraseña:</label>
          <input
            type="password"
            value={nuevaPassword}
            onChange={(e) => setNuevaPassword(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label>Confirmar Nueva Contraseña:</label>
          <input
            type="password"
            value={confirmarPassword}
            onChange={(e) => setConfirmarPassword(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="btn-login" disabled={guardando}>
          {guardando ? "Guardando..." : "Guardar nueva contraseña"}
        </button>
      </form>
    </div>
  );
};
